import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { PricelistGetSubstagesByStageId, PricelistGetSubstagesByStageIdResponse } from '../../api/dtos';


const getData = (response?: SWRResponse<PricelistGetSubstagesByStageIdResponse, PricelistGetSubstagesByStageIdResponse>) => response?.data?.subStages;
const getError = (response?: SWRResponse<PricelistGetSubstagesByStageIdResponse, PricelistGetSubstagesByStageIdResponse>) => (response?.error ?? response?.data)?.responseStatus;

const usePricelistSubstagesByStageId = (stageId?: number, configuration?: SWRConfiguration<PricelistGetSubstagesByStageIdResponse, PricelistGetSubstagesByStageIdResponse>) => {
    
    const request = useMemo(() => {

        return stageId ?
            () => {
                return new PricelistGetSubstagesByStageId({ stageId });
            } :
            undefined;
    }, [stageId])

    return useGet(request, { getData, getError }, configuration);
}

export default usePricelistSubstagesByStageId;